import { defineMessages } from 'react-intl';

const productCardGroupMessages = defineMessages({
  editProduct: {
    id: 'productCardGroup.dropdown.editProduct',
    defaultMessage: 'Edit Product Group',
    description: 'Product card edit product dropdown item',
  },
  deleteProduct: {
    id: 'productCardGroup.dropdown.deleteProduct',
    defaultMessage: 'Delete Product Group',
    description: 'Product card delete product dropdown item',
  },
  versions: {
    id: 'productCardGroup.version',
    defaultMessage: 'Versions',
    description: 'Product card versions label',
  },
  updatedOn: {
    id: 'productCardGroup.updatedOn',
    defaultMessage: 'Updated on {date} at {time}',
    description: 'Product card updatedOn label',
  },
});

export { productCardGroupMessages };
